var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertySearch } from '../models/index';
import { AbstractApartmentTypeSearch } from './shared/index';
var ApartmentTypesBaseComponent = /** @class */ (function (_super) {
    __extends(ApartmentTypesBaseComponent, _super);
    function ApartmentTypesBaseComponent(injector, agencyService, route, window, document) {
        var _this = _super.call(this, injector, window) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.window = window;
        _this.document = document;
        _this.apartmentTypes = [];
        return _this;
    }
    ApartmentTypesBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiLoading = true;
        this.route.data.forEach(function (data) {
            if (data.advanced_limits)
                _this.advancedLimits = data.advanced_limits;
            if (data.property_search)
                _this.routePropertySearch = data.property_search;
            AbstractApartmentTypeSearch.propertySearch = new PropertySearch();
        });
        this.subscription.add(this.route.queryParams
            .subscribe(function (params) {
            _this.validateRouteQueryParams(params);
            AbstractApartmentTypeSearch.propertySearch = _this.apartmentTypeService.decodeUrlParams(params, _this.advancedLimits);
            if (_this.routePropertySearch)
                for (var field in _this.routePropertySearch)
                    if (_this.routePropertySearch.hasOwnProperty(field)
                        && _this.routePropertySearch[field]
                        && field.length
                        && AbstractApartmentTypeSearch.propertySearch.hasOwnProperty(field)
                        && AbstractApartmentTypeSearch.propertySearch[field] === null)
                        AbstractApartmentTypeSearch.propertySearch[field] = _this.routePropertySearch[field];
            _this.refreshApartmentTypes();
        }));
        this.setTitle('Locuinte ' + this.agencyService.agency.name);
    };
    ApartmentTypesBaseComponent.prototype.updatePropertySearch = function (fieldName, fieldValue) {
        AbstractApartmentTypeSearch.propertySearch[fieldName] = fieldValue;
        this.refreshApartmentTypes();
    };
    ApartmentTypesBaseComponent.prototype.getCurrentScrollPosition = function () {
        return Math.max(this.document.body.scrollTop, this.document.documentElement.scrollTop);
    };
    return ApartmentTypesBaseComponent;
}(AbstractApartmentTypeSearch));
export { ApartmentTypesBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/apartment-types-base.component.ts.pre-build-optimizer.js